import DefaultCRUD from '../utils'
const resource = `/sector`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
